import GameModel from 'Models/GameModel';
import RegionModel from 'Models/RegionModel';
import FactionModel from 'Models/FactionModel';
import { ServerModel } from 'Models/WowModel';
import { ServerWowBcModel } from 'Models/WowBcModel';
import { RegionCodWarzoneModel } from 'Models/CodWarzoneModel';
import { FF14ServerModel } from 'Models/FF14Model';
import { OverwatchServerModel } from 'Models/OverwatchModel';
import { HearthstoneServerModel } from 'Models/HearthstoneModel';
import { GenshinImpactServerModel } from 'Models/GenshinImpactModel';
import { NewWorldRegionModel, NewWorldServerModel } from 'Models/NewWorldModel';
import { ValorantRegionModel } from 'Models/ValorantModel';
import { AccountInfo as DestinyAccountInfo } from 'Models/DestinyModel';
import { regExpDiscord, regExpFifaBackup } from 'Root/helpers/regexps';
import { ServerWowClassicModel } from 'Models/WowClassicModel';
import { WowWotlkModel } from 'Models/WowWotlkModel';
import { WowClassic20thModel } from 'Models/WowClassic20thModel';
import { WowClassicHardcoreModel } from 'Models/WowClassicHardcoreModel';
import { WowDiscoveryModel } from 'Models/WowDiscoveryModel';
import PlatformModel from 'Models/PlatformModel';
import { ThroneAndLibertyModel } from 'Models/ThroneAndLibertyModel';

const AccountInformationModel = {};

/* eslint-disable max-len */
AccountInformationModel.CONTACTS = {
  PHONE: {
    component: 'PhoneInput',
    name: 'phone',
    text: 'Phone number',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAxklEQVR42n2SAQoFIQhEhb2e9/J4XSjwF0aPGvrEQo09G10tv8dq2cfnt25r4xkZRygG0BWyK7hk0qADxMoTimAOwDkeSMMM+gQmTzZCjQpKrxoNFgNXBb51F0Dq8InsXcMS1zldKSpmuBsLA2qyULf8MKH5ubhMhSHwvCK7os+uzK0M6tLRiAcSMktck70zYydAh0DaanLUSQEHYX6lGQAg6h4EAES7hE0AEBw/AVmh76AA6DvVKU+n0Qoo1Mn+DwCL81//AHLH5GULCMohAAAAAElFTkSuQmCC',
    defaultValue: {},
  },
  DISCORD: {
    component: 'UiInput',
    text: 'Discord username, Example#7820',
    name: 'discord',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAMAAACgaw2xAAAAPFBMVEVHcEz///////////////////////////////////////////////////////////////////////////+PybD1AAAAE3RSTlMAC/QcE+fW+8osYbZ4qZqMbUVOulsP7AAAAMdJREFUGNNlUVsChCAIxAcCPivvf9dFs3a3+BkYQBgBOM2Yf1zmYml+OL7V6L50Req2lJRKsZ2w+pP33B/GZyY/+U558PJq0BbRRLTvhI06obz5TsmD4PRCoF9EgTjjakwdjmIbGTqgjTioKK+tqOjCYBrwvbgSwVyyGHA9CaLb2R3WUIQ5q4cYw8JTFsG1IC2gRcCUR38ipkRIA9OW0Go1WVR3KgSXeX6OHFvO2yE7ayXnsaZktnxfxzFxlnVOv8v3mrLPa3wAC2EU2bv9ewEAAAAASUVORK5CYII=',
    defaultValue: {},
  },
  FACEBOOK: {
    component: 'UiInput',
    text: 'Facebook ID',
    name: 'facebook',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAQAAABkO9ThAAAARUlEQVR42t3PQQoAIAhEUS88N/RsY1FBltIiWsXb+RFRTBw1DurH9LZx3MAWmAWtEM9KdxPQzIBOjCl9GtBwPX548PtQALgWvgGJKMk7AAAAAElFTkSuQmCC',
    defaultValue: {},
  },
  WHATSAPP: {
    component: 'PhoneInput',
    name: 'whatsapp',
    text: 'Phone number',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAtklEQVR42pWTUQ4DIQhETc/FrTjW3M9fmixtXyzKZjN/yptRxBGvjSy12xulVDEDKbwBfsW6BGo7wNncJPo/YCwXOXsA53LsDEBBuTUpCSR/m6TMGB/aAx8dj6UE8BedWkQ6wDEBCUCLizeAkVAa2AP7Z/IQMEcSniBX6QTm0rR1RZByjbYmex5z/C2BciiwXMWfBIB2kpgl4VgkDLn05LcB1W9FWydQkTBgNL6+Fr4Y0G6AZ3oDWgbnRR2E2SsAAAAASUVORK5CYII=',
    defaultValue: {},
  },
};

AccountInformationModel.ACCOUNTS = {
  BATTLETAG: {
    component: 'UiInput',
    text: 'BattleTag',
    placeholder: 'BattleTag',
    name: 'battleTag',
    required: true,
  },
  SUPERCELL_ID: {
    component: 'UiInput',
    placeholder: 'Supercell ID',
    name: 'supercellId',
    required: true,
  },
  IN_GAME_ID: {
    component: 'UiInput',
    placeholder: 'In game ID',
    name: 'inGameId',
    required: true,
  },
  IN_GAME_NAME: {
    component: 'UiInput',
    placeholder: 'In game name',
    name: 'inGameName',
    required: true,
  },
  STEAM_ID: {
    component: 'UiInput',
    placeholder: 'Steam ID',
    name: 'steamId',
    required: false,
  },
  EPICGAMES_NAME: {
    component: 'UiInput',
    placeholder: 'EpicGames Name',
    name: 'epicGamesName',
    required: false,
  },
  UBISOFT_ID: {
    component: 'UiInput',
    placeholder: 'Ubisoft ID',
    name: 'ubisoftId',
    required: false,
  },
  RIOT_ID: {
    component: 'UiInput',
    placeholder: 'Riot ID',
    name: 'riotId',
    required: true,
  },
  ACCOUNT_NAME: {
    component: 'UiInput',
    placeholder: 'Account Name',
    name: 'accountName',
    required: true,
  },
  FRIEND_CODE: {
    component: 'UiInput',
    placeholder: 'Friend Code',
    name: 'friendCode',
    required: true,
  },
};
/* eslint-enable max-len */

AccountInformationModel.WOW_GENERAL = {
  CHARACTER_NAME: {
    component: 'UiInput',
    text: 'Character name',
    name: 'characterName',
    defaultValue: '',
    required: true,
  },
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
  REGION: {
    component: 'UiPill',
    text: 'Region',
    items: RegionModel.LIST,
    titleField: 'shortTitle',
    valueField: 'id',
    name: 'region',
    linkedWith: ['server'],
  },
  FACTION: {
    component: 'UiPill',
    text: 'Faction',
    items: FactionModel.LIST,
    titleField: 'title',
    valueField: 'id',
    name: 'faction',
  },
};

AccountInformationModel[GameModel.WOW.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region, productId) => {
      if (productId && process.env.WOW_CLASSIC_GOLD_OFFER && productId === +process.env.WOW_CLASSIC_GOLD_OFFER) {
        return ServerWowClassicModel[region];
      }

      return ServerModel[region];
    },
  },
};

AccountInformationModel[GameModel.WOW_BC.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => ServerWowBcModel[region],
  },
};

AccountInformationModel[GameModel.WOW_WOTLK.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => WowWotlkModel[region],
  },
};

AccountInformationModel[GameModel.WOW_CATACLYSM.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => WowWotlkModel[region],
  },
};

AccountInformationModel[GameModel.WOW_CLASSIC_ERA.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => WowWotlkModel[region],
  },
};

AccountInformationModel[GameModel.WOW_CLASSIC_HARDCORE.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => WowClassicHardcoreModel[region],
  },
};

AccountInformationModel[GameModel.WOW_DISCOVERY.id] = {
  ...AccountInformationModel.WOW_GENERAL,
  SERVER_NAME: {
    component: 'SearchInput',
    text: 'Server name',
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
    getItems: (region) => WowDiscoveryModel[region],
  },
};

AccountInformationModel[GameModel.DESTINY.id] = {
  BUNGIE_NAME: {
    component: 'UiInput',
    text: 'Bungie name',
    name: 'bungieName',
    defaultValue: '',
    required: true,
    validationRegexp: regExpDiscord,
  },
  DESTINY_ID: {
    component: 'UiInput',
    text: 'Destiny ID',
    name: 'destinyId',
    defaultValue: '',
    required: false,
  },
  CHARACTER_CLASS: {
    component: 'UiKitSelect',
    text: 'Character class',
    items: DestinyAccountInfo.CLASS.LIST,
    titleField: 'title',
    valueField: 'id',
    name: 'class',
    defaultValue: null,
    required: true,
  },
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.DESTINY.platforms,
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
  CROSS_SAVE: {
    component: 'UiKitSelect',
    text: 'Cross save',
    items: DestinyAccountInfo.CROSS_SAVE.LIST,
    titleField: 'title',
    valueField: 'id',
    name: 'crossSave',
    defaultValue: null,
    required: false,
  },
};

// eslint-disable-next-line max-len
AccountInformationModel[GameModel.DESTINY.id].DESTINY_ID.shouldActAs = AccountInformationModel[GameModel.DESTINY.id].BUNGIE_NAME;

AccountInformationModel[GameModel.COD_MW.id] = {
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.COD_MW.platforms,
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
  REGION: {
    component: 'UiKitSelect',
    text: 'Region',
    items: RegionCodWarzoneModel,
    titleField: 'title',
    valueField: 'id',
    name: 'server',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel.ADDITIONAL_INFORMATION = {
  component: 'UiInput',
  text: 'Additional information',
  placeholder: 'Additional information',
  name: 'additionalInfo',
  defaultValue: '',
};

AccountInformationModel.VPN_LOCATION = {
  component: 'UiInput',
  text: 'VPN location',
  placeholder: 'VPN location',
  name: 'vpn_location',
  defaultValue: '',
};

AccountInformationModel[GameModel.APEX_LEGENDS.id] = {
  PLATFORM: {
    component: 'UiKitSelect',
    placeholder: 'Platform',
    name: 'platform',
    valueField: 'id',
    items: GameModel.APEX_LEGENDS.platforms,
    defaultValue: null,
    required: true,
  },
  ACCOUNT_TAG: {
    component: 'UiInput',
    placeholder: 'Account tag',
    name: 'accountTag',
    required: true,
  },
};

AccountInformationModel[GameModel.FF14.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
  SERVER: {
    component: 'SearchInput',
    titleField: 'title',
    placeholder: 'Server',
    name: 'server',
    valueField: 'id',
    items: FF14ServerModel,
    defaultValue: null,
    required: true,
  },
  REGION: {
    component: 'UiKitSelect',
    placeholder: 'Region',
    name: 'customRegion',
    items: [
      'EU',
      'NA',
      'JP',
      'OCE',
    ],
    titleField: false,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.OVERWATCH.id] = {
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
  SERVER: {
    component: 'UiKitSelect',
    placeholder: 'Server',
    name: 'server',
    valueField: 'id',
    items: OverwatchServerModel,
    defaultValue: null,
    required: true,
  },
  PLATFORM: {
    component: 'UiKitSelect',
    placeholder: 'Platform',
    name: 'platform',
    valueField: 'id',
    items: GameModel.OVERWATCH.platforms,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.HEARTHSTONE.id] = {
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
  SERVER: {
    component: 'UiKitSelect',
    placeholder: 'Server',
    name: 'server',
    valueField: 'id',
    items: HearthstoneServerModel,
    defaultValue: null,
    required: true,
  },
  PLATFORM: {
    component: 'UiKitSelect',
    placeholder: 'Platform',
    name: 'platform',
    valueField: 'id',
    items: GameModel.HEARTHSTONE.platforms,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.GENSHIN_IMPACT.id] = {
  SERVER: {
    component: 'UiKitSelect',
    placeholder: 'Server',
    name: 'server',
    valueField: 'id',
    items: GenshinImpactServerModel,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.NEW_WORLD.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
  REGION: {
    component: 'UiKitSelect',
    placeholder: 'Region',
    name: 'region',
    valueField: 'id',
    items: NewWorldRegionModel.LIST,
    defaultValue: null,
    required: true,
    linkedWith: ['server'],
  },
  SERVER: {
    component: 'SearchInput',
    placeholder: 'Server',
    name: 'server',
    valueField: 'id',
    titleField: 'title',
    getItems: (region) => NewWorldServerModel[region],
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.PATH_OF_EXILE.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
};

AccountInformationModel[GameModel.PATH_OF_EXILE_2.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
};

AccountInformationModel[GameModel.VALORANT.id] = {
  RIOT_ID: AccountInformationModel.ACCOUNTS.RIOT_ID,
  REGION: {
    component: 'UiKitSelect',
    placeholder: 'Region',
    name: 'region',
    valueField: 'id',
    items: ValorantRegionModel.LIST,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.DIABLO_IMMORTAL.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
};

AccountInformationModel[GameModel.FIFA.id] = {
  ORIGIN_EMAIL: {
    component: 'UiInput',
    placeholder: 'Origin email',
    name: 'originEmail',
    required: true,
  },
  ORIGIN_PASSWORD: {
    component: 'UiInput',
    placeholder: 'Origin password',
    name: 'originPassword',
    type: 'password',
    required: true,
  },
  COINS_AMOUNT: {
    component: 'UiInput',
    placeholder: 'Current coins amount',
    name: 'currentCoinsAmount',
    type: 'number',
    inputmode: 'numeric',
    required: true,
  },
  BACKUP_CODE_1: {
    component: 'UiInput',
    placeholder: 'Backup code 1',
    name: 'backupCode1',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_2: {
    component: 'UiInput',
    placeholder: 'Backup code 2',
    name: 'backupCode2',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_3: {
    component: 'UiInput',
    placeholder: 'Backup code 3',
    name: 'backupCode3',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_4: {
    component: 'UiInput',
    placeholder: 'Backup code 4',
    name: 'backupCode4',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_5: {
    component: 'UiInput',
    placeholder: 'Backup code 5',
    name: 'backupCode5',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_6: {
    component: 'UiInput',
    placeholder: 'Backup code 6',
    name: 'backupCode6',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
};

AccountInformationModel[GameModel.FIFA_24.id] = {
  ORIGIN_EMAIL: {
    component: 'UiInput',
    placeholder: 'Origin email',
    name: 'originEmail',
    required: true,
  },
  ORIGIN_PASSWORD: {
    component: 'UiInput',
    placeholder: 'Origin password',
    name: 'originPassword',
    type: 'password',
    required: true,
  },
  COINS_AMOUNT: {
    component: 'UiInput',
    placeholder: 'Current coins amount',
    name: 'currentCoinsAmount',
    type: 'number',
    inputmode: 'numeric',
    required: true,
  },
  BACKUP_CODE_1: {
    component: 'UiInput',
    placeholder: 'Backup code 1',
    name: 'backupCode1',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_2: {
    component: 'UiInput',
    placeholder: 'Backup code 2',
    name: 'backupCode2',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_3: {
    component: 'UiInput',
    placeholder: 'Backup code 3',
    name: 'backupCode3',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_4: {
    component: 'UiInput',
    placeholder: 'Backup code 4',
    name: 'backupCode4',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_5: {
    component: 'UiInput',
    placeholder: 'Backup code 5',
    name: 'backupCode5',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_6: {
    component: 'UiInput',
    placeholder: 'Backup code 6',
    name: 'backupCode6',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
};

AccountInformationModel[GameModel.FC_25.id] = {
  ORIGIN_EMAIL: {
    component: 'UiInput',
    placeholder: 'Web App email',
    name: 'originEmail',
    required: true,
  },
  ORIGIN_PASSWORD: {
    component: 'UiInput',
    placeholder: 'Web App password',
    name: 'originPassword',
    type: 'password',
    required: true,
  },
  COINS_AMOUNT: {
    component: 'UiInput',
    placeholder: 'Current coins amount',
    name: 'currentCoinsAmount',
    type: 'number',
    inputmode: 'numeric',
    required: true,
  },
  BACKUP_CODE_1: {
    component: 'UiInput',
    placeholder: 'Backup code 1',
    name: 'backupCode1',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_2: {
    component: 'UiInput',
    placeholder: 'Backup code 2',
    name: 'backupCode2',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_3: {
    component: 'UiInput',
    placeholder: 'Backup code 3',
    name: 'backupCode3',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_4: {
    component: 'UiInput',
    placeholder: 'Backup code 4',
    name: 'backupCode4',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_5: {
    component: 'UiInput',
    placeholder: 'Backup code 5',
    name: 'backupCode5',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
  BACKUP_CODE_6: {
    component: 'UiInput',
    placeholder: 'Backup code 6',
    name: 'backupCode6',
    required: true,
    validationRegexp: regExpFifaBackup,
  },
};

AccountInformationModel.CONTACTS.LIST = [
  AccountInformationModel.CONTACTS.DISCORD,
  AccountInformationModel.CONTACTS.WHATSAPP,
  AccountInformationModel.CONTACTS.FACEBOOK,
  AccountInformationModel.CONTACTS.PHONE,
];

AccountInformationModel[GameModel.WOW.id].LIST = [
  AccountInformationModel[GameModel.WOW.id].CHARACTER_NAME,
  AccountInformationModel[GameModel.WOW.id].BATTLETAG,
  AccountInformationModel[GameModel.WOW.id].REGION,
  AccountInformationModel[GameModel.WOW.id].FACTION,
  AccountInformationModel[GameModel.WOW.id].SERVER_NAME,
];

AccountInformationModel[GameModel.DESTINY.id].LIST = [
  AccountInformationModel[GameModel.DESTINY.id].BUNGIE_NAME,
  AccountInformationModel[GameModel.DESTINY.id].DESTINY_ID,
  AccountInformationModel[GameModel.DESTINY.id].CHARACTER_CLASS,
  AccountInformationModel[GameModel.DESTINY.id].PLATFORM,
  AccountInformationModel[GameModel.DESTINY.id].CROSS_SAVE,
];

AccountInformationModel[GameModel.DIABLO_4.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name',
    name: 'characterName',
    required: true,
  },
  BATTLETAG: AccountInformationModel.ACCOUNTS.BATTLETAG,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.DIABLO_4.platforms,
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.BRAWL_STARS.id] = {
  SUPERCELL_ID: AccountInformationModel.ACCOUNTS.SUPERCELL_ID,
  BRAWL_TAG_ID: {
    component: 'UiInput',
    placeholder: 'Brawl Tag ID',
    name: 'brawlTagId',
    required: true,
  },
};

AccountInformationModel[GameModel.RUNESCAPE.id] = {
  RUNESCAPE_NAME: {
    component: 'UiInput',
    placeholder: 'RuneScape Name',
    name: 'runescapeName',
    required: true,
  },
};

AccountInformationModel[GameModel.RUNESCAPE_OLD_SCHOOL.id] = {
  RUNESCAPE_NAME: {
    component: 'UiInput',
    placeholder: 'RuneScape Name',
    name: 'runescapeName',
    required: true,
  },
};

AccountInformationModel[GameModel.ESCAPE_FROM_TARKOV.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    text: 'Character name',
    placeholder: 'Character name',
    name: 'characterName',
    defaultValue: '',
    required: true,
  },
};

AccountInformationModel[GameModel.RAINBOW_SIX_SIEGE.id] = {
  UBISOFT_ID: AccountInformationModel.ACCOUNTS.UBISOFT_ID,
  STEAM_ID: AccountInformationModel.ACCOUNTS.STEAM_ID,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: [
      PlatformModel.PC,
      PlatformModel.XBOX,
      PlatformModel.PLAYSTATION,
    ],
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },

};

AccountInformationModel[GameModel.DIVISION_2.id] = {
  IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  FRIEND_CODE: AccountInformationModel.ACCOUNTS.FRIEND_CODE,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: [
      PlatformModel.PC,
      PlatformModel.XBOX,
      PlatformModel.PLAYSTATION,
    ],
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.LOL.id] = {
  RIOT_ID: AccountInformationModel.ACCOUNTS.RIOT_ID,
  // REGION: {
  //   component: 'UiKitSelect',
  //   placeholder: 'Region',
  //   name: 'customRegion',
  //   items: [
  //     'EU Nordic & East',
  //     'EU West',
  //     'Japan',
  //     'Latin America North',
  //     'Latin America South',
  //     'North America',
  //     'Turkey',
  //   ],
  //   titleField: false,
  //   defaultValue: null,
  //   required: true,
  // },
};

AccountInformationModel[GameModel.FORTNITE.id] = {
  EPICGAMES_NAME: AccountInformationModel.ACCOUNTS.EPICGAMES_NAME,
  REGION: {
    component: 'UiKitSelect',
    placeholder: 'Region',
    name: 'customRegion',
    items: [
      'NA-East',
      'NA-Central',
      'NA-West',
      'Europe',
      'Oceania',
      'Brazil',
      'Asia',
      'Middle East',
    ],
    titleField: false,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.TESO.id] = {
  CHARACTER_NAME: {
    component: 'UiInput',
    placeholder: 'Character name or User ID',
    name: 'characterName',
    required: true,
  },
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: [
      PlatformModel.PC,
      PlatformModel.XBOX,
      PlatformModel.PLAYSTATION,
    ],
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
  REGION: {
    component: 'UiKitSelect',
    placeholder: 'Region',
    name: 'customRegion',
    items: [
      'EU',
      'US',
    ],
    titleField: false,
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.ALBION_ONLINE.id] = {};

AccountInformationModel[GameModel.LAST_EPOCH.id] = {
  ACCOUNT_NAME: AccountInformationModel.ACCOUNTS.ACCOUNT_NAME,
};

AccountInformationModel[GameModel.WARFRAME.id] = {
  IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.WARFRAME.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },

};

AccountInformationModel[GameModel.BLACK_DESERT_ONLINE.id] = {
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.BLACK_DESERT_ONLINE.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.GTA.id] = {
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.GTA.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.GUILD_WARS_2.id] = {};

AccountInformationModel[GameModel.MOBILE_LEGENDS.id] = {
  IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.MOBILE_LEGENDS.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.THE_FINALS.id] = {
  ACCOUNT_NAME: AccountInformationModel.ACCOUNTS.ACCOUNT_NAME,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.THE_FINALS.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },

};

AccountInformationModel[GameModel.BATTLEFIELD_2042.id] = {
  IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  PLATFORM: {
    component: 'UiKitSelect',
    text: 'Platform',
    items: GameModel.BATTLEFIELD_2042.platforms,
    placeholder: 'Platform',
    titleField: 'title',
    valueField: 'id',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.EVE_ONLINE.id] = {};

AccountInformationModel[GameModel.STAR_WARS_THE_OLD_REPUBLIC.id] = {};

AccountInformationModel[GameModel.REMNANT_2.id] = {
  ACCOUNT_NAME: AccountInformationModel.ACCOUNTS.ACCOUNT_NAME,
};

AccountInformationModel[GameModel.MONSTER_HUNTER_WORLD.id] = {
  ACCOUNT_NAME: AccountInformationModel.ACCOUNTS.ACCOUNT_NAME,
};

AccountInformationModel[GameModel.WOT.id] = {
  ACCOUNT_NAME: AccountInformationModel.ACCOUNTS.ACCOUNT_NAME,
};

AccountInformationModel[GameModel.CLASH_OF_CLANS.id] = {
  SUPERCELL_ID: AccountInformationModel.ACCOUNTS.SUPERCELL_ID,
};

AccountInformationModel[GameModel.PALIA.id] = {};

AccountInformationModel[GameModel.NBA.id] = {};

AccountInformationModel[GameModel.MADDEN_NFL.id] = {};

AccountInformationModel[GameModel.NHL.id] = {};

AccountInformationModel[GameModel.MLB.id] = {};

AccountInformationModel[GameModel.LOST_ARK.id] = {};

AccountInformationModel[GameModel.WARCRAFT_RUMBLE.id] = {};

AccountInformationModel[GameModel.HONKAI_STAR_RAIL.id] = {};

AccountInformationModel[GameModel.ROCKET_LEAGUE.id] = {};

AccountInformationModel[GameModel.DOTA_2.id] = {};

AccountInformationModel[GameModel.DARK_AND_DARKER.id] = {};

AccountInformationModel[GameModel.RED_DEAD_REDEMPTION_2.id] = {};

AccountInformationModel[GameModel.ELDEN_RING.id] = {};

AccountInformationModel[GameModel.ENSHROUDED.id] = {};

AccountInformationModel[GameModel.PALWORLD.id] = {};

AccountInformationModel[GameModel.HELLDIVERS_2.id] = {
  FRIEND_CODE: AccountInformationModel.ACCOUNTS.FRIEND_CODE,
  PLATFORM: {
    component: 'UiKitSelect',
    items: [
      PlatformModel.PC,
      PlatformModel.XBOX,
      PlatformModel.PLAYSTATION,
    ],
    titleField: 'title',
    valueField: 'id',
    placeholder: 'Platform',
    name: 'platform',
    defaultValue: null,
    required: true,
  },
};

AccountInformationModel[GameModel.COUNTER_STRIKE_2.id] = {};

if (GameModel.FALLOUT_76) {
  AccountInformationModel[GameModel.FALLOUT_76.id] = {};
}

if (GameModel.DEAD_BY_DAYLIGHT) {
  AccountInformationModel[GameModel.DEAD_BY_DAYLIGHT.id] = {};
}

if (GameModel.FORZA_HORIZON_5) {
  AccountInformationModel[GameModel.FORZA_HORIZON_5.id] = {};
}

if (GameModel.NIGHT_CROWS) {
  AccountInformationModel[GameModel.NIGHT_CROWS.id] = {};
}

if (GameModel.GRAY_ZONE_WARFARE) {
  AccountInformationModel[GameModel.GRAY_ZONE_WARFARE.id] = {};
}

if (GameModel.TARISLAND) {
  AccountInformationModel[GameModel.TARISLAND.id] = {
    CHARACTER_NAME: {
      component: 'UiInput',
      text: 'Character name',
      placeholder: 'Character name',
      name: 'characterName',
      defaultValue: '',
      required: true,
    },
    SERVER: {
      component: 'UiKitSelect',
      placeholder: 'Server',
      name: 'customRegion',
      items: [
        'NA',
        'EU',
        'ASIA',
        'LATAM',
        'EE',
      ],
      titleField: false,
      defaultValue: null,
      required: true,
    },
  };
}

if (GameModel.THRONE_AND_LIBERTY) {
  AccountInformationModel[GameModel.THRONE_AND_LIBERTY.id] = {
    CHARACTER_NAME: {
      component: 'UiInput',
      text: 'Character name',
      placeholder: 'Character name',
      name: 'characterName',
      defaultValue: '',
      required: true,
    },
    REGION: {
      component: 'UiKitSelect',
      placeholder: 'Region',
      name: 'customRegion',
      items: [
        'America West',
        'America East',
        'South America',
        'Europe',
        'Japan & Oceania',
      ],
      titleField: '',
      defaultValue: null,
      required: true,
    },
    SERVER_NAME: {
      component: 'UiKitSelect',
      placeholder: 'Server',
      name: 'customServer',
      titleField: '',
      defaultValue: null,
      required: true,
      getItems: (region) => ThroneAndLibertyModel[region],
    },
    PLATFORM: {
      component: 'UiKitSelect',
      text: 'Platform',
      items: GameModel.THRONE_AND_LIBERTY.platforms,
      titleField: 'title',
      valueField: 'id',
      name: 'platform',
      defaultValue: null,
      required: true,
    },
  };
}

if (GameModel.TOWER_OF_FANTASY) {
  AccountInformationModel[GameModel.TOWER_OF_FANTASY.id] = {};
}

if (GameModel.WAYFINDER) {
  AccountInformationModel[GameModel.WAYFINDER.id] = {
    IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  };
}

if (GameModel.PAYDAY_3) {
  AccountInformationModel[GameModel.PAYDAY_3.id] = {
    IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  };
}

if (GameModel.THE_FIRST_DESCENDANT) {
  AccountInformationModel[GameModel.THE_FIRST_DESCENDANT.id] = {};
}

if (GameModel.QUINFALL) {
  AccountInformationModel[GameModel.QUINFALL.id] = {};
}

if (GameModel.WOW_THE_WAR_WITHIN) {
  AccountInformationModel[GameModel.WOW_THE_WAR_WITHIN.id] = {
    ...AccountInformationModel.WOW_GENERAL,
    SERVER_NAME: {
      component: 'SearchInput',
      text: 'Server name',
      titleField: 'title',
      valueField: 'id',
      name: 'server',
      defaultValue: null,
      required: true,
      getItems: (region) => WowWotlkModel[region],
    },
  };
}

if (GameModel.GREED_IS_GOOD) {
  AccountInformationModel[GameModel.GREED_IS_GOOD.id] = {};
}

if (GameModel.FRACTURED_ONLINE) {
  AccountInformationModel[GameModel.FRACTURED_ONLINE.id] = {};
}

if (GameModel.XDEFIANT) {
  AccountInformationModel[GameModel.XDEFIANT.id] = {};
}

if (GameModel.PUBG_MOBILE) {
  AccountInformationModel[GameModel.PUBG_MOBILE.id] = {
    IN_GAME_ID: AccountInformationModel.ACCOUNTS.IN_GAME_ID,
  };
}

if (GameModel.CLASH_ROYALE) {
  AccountInformationModel[GameModel.CLASH_ROYALE.id] = {
    SUPERCELL_ID: AccountInformationModel.ACCOUNTS.SUPERCELL_ID,
  };
}

if (GameModel.WOW_CLASSIC_20TH_ANNIVERSARY) {
  AccountInformationModel[GameModel.WOW_CLASSIC_20TH_ANNIVERSARY.id] = {
    ...AccountInformationModel.WOW_GENERAL,
    SERVER_NAME: {
      component: 'SearchInput',
      text: 'Server name',
      titleField: 'title',
      valueField: 'id',
      name: 'server',
      defaultValue: null,
      required: true,
      getItems: (region) => WowClassic20thModel[region],
    },
  };
}

function generateForPro(GameID, fieldName, isSensitive = false) {
  return {
    title: AccountInformationModel[GameID][fieldName].placeholder ?? AccountInformationModel[GameID][fieldName].text,
    name: AccountInformationModel[GameID][fieldName].name,
    isSensitive,
    ...(
      AccountInformationModel[GameID][fieldName].items
        ? ({ items: AccountInformationModel[GameID][fieldName].items })
        : []
    ),
  };
}

AccountInformationModel.FOR_PRO = {
  GAME_TO_FIELDS: {
    [GameModel.WOW.id]: [
      {
        title: AccountInformationModel[GameModel.WOW.id].SERVER_NAME.text,
        name: AccountInformationModel[GameModel.WOW.id].SERVER_NAME.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW.id].FACTION.text,
        name: AccountInformationModel[GameModel.WOW.id].FACTION.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW.id].CHARACTER_NAME.text,
        name: AccountInformationModel[GameModel.WOW.id].CHARACTER_NAME.name,
        isSensitive: true,
      },
    ],
    [GameModel.DESTINY.id]: [
      generateForPro(GameModel.DESTINY.id, 'CHARACTER_CLASS', false),
    ],
    [GameModel.COD_MW.id]: [
      {
        title: AccountInformationModel[GameModel.COD_MW.id].REGION.text,
        name: AccountInformationModel[GameModel.COD_MW.id].REGION.name,
      },
      generateForPro(GameModel.OVERWATCH.id, 'BATTLETAG', true),
    ],
    [GameModel.WOW_BC.id]: [
      {
        title: AccountInformationModel[GameModel.WOW_BC.id].SERVER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_BC.id].SERVER_NAME.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_BC.id].FACTION.text,
        name: AccountInformationModel[GameModel.WOW_BC.id].FACTION.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_BC.id].CHARACTER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_BC.id].CHARACTER_NAME.name,
        isSensitive: true,
      },
    ],
    [GameModel.WOW_WOTLK.id]: [
      {
        title: AccountInformationModel[GameModel.WOW_WOTLK.id].SERVER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_WOTLK.id].SERVER_NAME.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_WOTLK.id].FACTION.text,
        name: AccountInformationModel[GameModel.WOW_WOTLK.id].FACTION.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_WOTLK.id].CHARACTER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_WOTLK.id].CHARACTER_NAME.name,
        isSensitive: true,
      },
    ],
    [GameModel.WOW_CATACLYSM.id]: [
      {
        title: AccountInformationModel[GameModel.WOW_CATACLYSM.id].SERVER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_CATACLYSM.id].SERVER_NAME.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_CATACLYSM.id].FACTION.text,
        name: AccountInformationModel[GameModel.WOW_CATACLYSM.id].FACTION.name,
      },
      {
        title: AccountInformationModel[GameModel.WOW_CATACLYSM.id].CHARACTER_NAME.text,
        name: AccountInformationModel[GameModel.WOW_CATACLYSM.id].CHARACTER_NAME.name,
        isSensitive: true,
      },
      generateForPro(GameModel.WOW_CATACLYSM.id, 'BATTLETAG', true),
    ],
    [GameModel.NEW_WORLD.id]: [
      {
        title: AccountInformationModel[GameModel.NEW_WORLD.id].SERVER.placeholder,
        name: AccountInformationModel[GameModel.NEW_WORLD.id].SERVER.name,
      },
      {
        title: AccountInformationModel[GameModel.NEW_WORLD.id].CHARACTER_NAME.placeholder,
        name: AccountInformationModel[GameModel.NEW_WORLD.id].CHARACTER_NAME.name,
        isSensitive: true,
      },
    ],
    [GameModel.VALORANT.id]: [
      generateForPro(GameModel.VALORANT.id, 'RIOT_ID', true),
      generateForPro(GameModel.VALORANT.id, 'REGION', false),
    ],
    [GameModel.APEX_LEGENDS.id]: [],
    [GameModel.PATH_OF_EXILE.id]: [
      generateForPro(GameModel.PATH_OF_EXILE.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.PATH_OF_EXILE_2.id]: [
      generateForPro(GameModel.PATH_OF_EXILE_2.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.FF14.id]: [
      generateForPro(GameModel.FF14.id, 'SERVER', false),
      generateForPro(GameModel.FF14.id, 'REGION', false),
      generateForPro(GameModel.FF14.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.OVERWATCH.id]: [
      {
        title: AccountInformationModel[GameModel.OVERWATCH.id].SERVER.placeholder,
        name: AccountInformationModel[GameModel.OVERWATCH.id].SERVER.name,
      },
      generateForPro(GameModel.OVERWATCH.id, 'BATTLETAG', true),
    ],
    [GameModel.HEARTHSTONE.id]: [
      {
        title: AccountInformationModel[GameModel.HEARTHSTONE.id].SERVER.placeholder,
        name: AccountInformationModel[GameModel.HEARTHSTONE.id].SERVER.name,
      },
      generateForPro(GameModel.HEARTHSTONE.id, 'BATTLETAG', true),
      generateForPro(GameModel.HEARTHSTONE.id, 'PLATFORM', false),
    ],
    [GameModel.GENSHIN_IMPACT.id]: [
      generateForPro(GameModel.GENSHIN_IMPACT.id, 'SERVER', false),
    ],
    [GameModel.FIFA.id]: [
      {
        title: AccountInformationModel[GameModel.FIFA.id].ORIGIN_EMAIL.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].ORIGIN_EMAIL.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].ORIGIN_PASSWORD.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].ORIGIN_PASSWORD.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_1.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_1.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_2.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_2.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_3.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_3.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_4.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_4.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_5.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_5.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_6.placeholder,
        name: AccountInformationModel[GameModel.FIFA.id].BACKUP_CODE_6.name,
        isSensitive: true,
      },
    ],
    [GameModel.FIFA_24.id]: [
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].ORIGIN_EMAIL.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].ORIGIN_EMAIL.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].ORIGIN_PASSWORD.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].ORIGIN_PASSWORD.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_1.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_1.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_2.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_2.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_3.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_3.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_4.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_4.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_5.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_5.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_6.placeholder,
        name: AccountInformationModel[GameModel.FIFA_24.id].BACKUP_CODE_6.name,
        isSensitive: true,
      },
    ],
    [GameModel.FC_25.id]: [
      {
        title: AccountInformationModel[GameModel.FC_25.id].ORIGIN_EMAIL.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].ORIGIN_EMAIL.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].ORIGIN_PASSWORD.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].ORIGIN_PASSWORD.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_1.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_1.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_2.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_2.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_3.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_3.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_4.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_4.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_5.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_5.name,
        isSensitive: true,
      },
      {
        title: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_6.placeholder,
        name: AccountInformationModel[GameModel.FC_25.id].BACKUP_CODE_6.name,
        isSensitive: true,
      },
    ],
    [GameModel.BRAWL_STARS.id]: [
      generateForPro(GameModel.BRAWL_STARS.id, 'SUPERCELL_ID', true),
      generateForPro(GameModel.BRAWL_STARS.id, 'BRAWL_TAG_ID', true),
    ],
    [GameModel.RUNESCAPE.id]: [
      generateForPro(GameModel.RUNESCAPE.id, 'RUNESCAPE_NAME', true),
    ],
    [GameModel.RUNESCAPE_OLD_SCHOOL.id]: [
      generateForPro(GameModel.RUNESCAPE_OLD_SCHOOL.id, 'RUNESCAPE_NAME', true),
    ],
    [GameModel.DIABLO_4.id]: [
      generateForPro(GameModel.DIABLO_4.id, 'CHARACTER_NAME', true),
      generateForPro(GameModel.DIABLO_4.id, 'BATTLETAG', true),
      generateForPro(GameModel.DIABLO_4.id, 'PLATFORM', false),
    ],
    [GameModel.DIABLO_IMMORTAL.id]: [
      generateForPro(GameModel.DIABLO_IMMORTAL.id, 'CHARACTER_NAME', true),
      generateForPro(GameModel.DIABLO_IMMORTAL.id, 'BATTLETAG', true),
    ],
    [GameModel.ESCAPE_FROM_TARKOV.id]: [
      generateForPro(GameModel.ESCAPE_FROM_TARKOV.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.RAINBOW_SIX_SIEGE.id]: [
      generateForPro(GameModel.RAINBOW_SIX_SIEGE.id, 'UBISOFT_ID', true),
      generateForPro(GameModel.RAINBOW_SIX_SIEGE.id, 'STEAM_ID', true),
      generateForPro(GameModel.RAINBOW_SIX_SIEGE.id, 'PLATFORM', false),
    ],
    [GameModel.DIVISION_2.id]: [
      generateForPro(GameModel.DIVISION_2.id, 'FRIEND_CODE', true),
      generateForPro(GameModel.DIVISION_2.id, 'PLATFORM', false),
    ],
    [GameModel.HELLDIVERS_2.id]: [
      generateForPro(GameModel.HELLDIVERS_2.id, 'FRIEND_CODE', true),
      generateForPro(GameModel.HELLDIVERS_2.id, 'PLATFORM', false),
    ],
    [GameModel.LOL.id]: [
      generateForPro(GameModel.LOL.id, 'RIOT_ID', true),
    ],
    [GameModel.TARISLAND.id]: [
      generateForPro(GameModel.TARISLAND.id, 'SERVER', false),
      generateForPro(GameModel.TARISLAND.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.TESO.id]: [
      generateForPro(GameModel.TESO.id, 'CHARACTER_NAME', true),
      generateForPro(GameModel.TESO.id, 'REGION', false),
      generateForPro(GameModel.TESO.id, 'PLATFORM', false),
    ],
    [GameModel.WOW_CATACLYSM.id]: [
      generateForPro(GameModel.WOW_CATACLYSM.id, 'SERVER_NAME', false),
      generateForPro(GameModel.WOW_CATACLYSM.id, 'FACTION', false),
      generateForPro(GameModel.WOW_CATACLYSM.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.WOW_CLASSIC_ERA.id]: [
      generateForPro(GameModel.WOW_CLASSIC_ERA.id, 'SERVER_NAME', false),
      generateForPro(GameModel.WOW_CLASSIC_ERA.id, 'FACTION', false),
      generateForPro(GameModel.WOW_CLASSIC_ERA.id, 'CHARACTER_NAME', true),
    ],
    [GameModel?.WOW_CLASSIC_20TH_ANNIVERSARY?.id]: [
      generateForPro(GameModel?.WOW_CLASSIC_20TH_ANNIVERSARY?.id, 'SERVER_NAME', false),
      generateForPro(GameModel?.WOW_CLASSIC_20TH_ANNIVERSARY?.id, 'FACTION', false),
      generateForPro(GameModel?.WOW_CLASSIC_20TH_ANNIVERSARY?.id, 'CHARACTER_NAME', true),
    ],
    [GameModel.FORTNITE.id]: [
      generateForPro(GameModel.FORTNITE.id, 'EPICGAMES_NAME', true),
      generateForPro(GameModel.FORTNITE.id, 'REGION', false),
    ],
    [GameModel.THRONE_AND_LIBERTY.id]: [
      generateForPro(GameModel.THRONE_AND_LIBERTY.id, 'CHARACTER_NAME', true),
      generateForPro(GameModel.THRONE_AND_LIBERTY.id, 'REGION', false),
      generateForPro(GameModel.THRONE_AND_LIBERTY.id, 'SERVER_NAME', false),
      generateForPro(GameModel.THRONE_AND_LIBERTY.id, 'PLATFORM', false),
    ],
  },
};

export default AccountInformationModel;
